import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Button, Card, CardGroup, Col, Container, Row } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { FloatingControlComponent } from "../../../components/FormComponent";
import CardDisplayComponent from "../../../components/CardDisplayComponent";
import CompaniesService from "../../../services/company.service";

export default function CompanyProfile() {
  const { user } = useAuth();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const [data, setData] = useState();
  const infoField = [
    {
      label: "ข้อมูลทั่วไป",
      field: [
        { name: "Com_Code", label: "รหัสบริษัท" },
        { name: "Com_Name", label: "ชื่อบริษัท" },
        { name: "ReportHead_TH", label: "หัวรายงาน", size: 6 }
      ]
    },
    {
      label: "ข้อมูลที่อยู่บริษัท",
      field: [
        { name: "Com_Addes", label: "ที่อยู่", size: 6 },
        { name: "Com_Road", label: "ถนน" },
        { name: "Com_SubDistrict", label: "ตําบล/แขวง" },
        { name: "Com_District", label: "อำเภอ/เขต" },
        { name: "Com_Province", label: "จังหวัด" },
        { name: "Com_ZipCode", label: "รหัสไปรษณีย์" },
        { name: "Com_Country", label: "ประเทศ" }
      ]
    },
    {
      label: "ข้อมูลการติดต่อ",
      field: [
        { name: "Com_Tel1", label: "เบอร์โทร 1" },
        { name: "Com_Tel2", label: "เบอร์โทร 2" },
        { name: "Com_Fax", label: "เบอร์แฟกซ์" },
        { name: "Com_Email", label: "อีเมล" }
      ]
    }
  ];

  const findAndPrintLocation = (response, keyword) => {
    const addressParts = response?.Com_Addes.split(" ");
    const index = addressParts.findIndex((part) => part.includes(keyword));
    return index !== -1 ? addressParts[index].replace(keyword, "") : "";
  };

  useEffect(() => {
    setLoading(true);
    CompaniesService.getCompanies(user.Com_Code)
      .then((response) =>
        setData({
          ...response,
          Com_Road: findAndPrintLocation(response, "ถนน"),
          Com_SubDistrict:
            findAndPrintLocation(response, "แขวง") ||
            findAndPrintLocation(response, "ตำบล"),
          Com_District:
            findAndPrintLocation(response, "เขต") ||
            findAndPrintLocation(response, "อำเภอ")
        })
      )
      .catch(({ error, message }) =>
        showAlert({ error, message, type: "danger" })
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>ข้อมูลบริษัท</title>
        <meta name="description" content="Company Information Page" />
      </Helmet>

      <Container fluid className="p-3">
        <CardDisplayComponent
          header={{
            className: "pb-0 text-end",
            button: (
              <Button
                variant="success"
                className="px-5 pt-2 text-dark rounded-pill"
              >
                อัพโหลดข้อมูล
              </Button>
            )
          }}
          body={{
            className: "p-0",
            element: infoField.map(({ label, field }, index) => (
              <CardGroup key={index} className="p-3 pt-0 flex-column">
                <Card.Header className="mb-4 p-0 pb-2 bg-transparent">
                  <Card.Title className="fs-2">{label}</Card.Title>
                </Card.Header>

                <Card.Body className="p-0">
                  <Row>
                    {field.map(({ label, name, size }, idx) => (
                      <Col
                        key={`${index}-${idx}`}
                        sm={size || 3}
                        className={`mt-1 ${index !== 2 ? "mb-3" : ""} fs-4`}
                      >
                        <FloatingControlComponent
                          readOnly
                          type="text"
                          name={name}
                          label={label}
                          value={data?.[name] || "-"}
                        />
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </CardGroup>
            ))
          }}
        />
      </Container>
    </>
  );
}
